import React from "react";
import PlaceholderPage from "./PlaceholderPage";

/** Placeholder page for page template management. */
const Template: React.FC = () => (
	<PlaceholderPage title="Template" description="Template management will be available soon." />
);

export default Template;
